import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

import { catchError, filter, map, Observable, of, switchMap, withLatestFrom } from 'rxjs';

import * as DataAccessEventsActions from './data-access-events.actions';
import * as DataAccessEventsReducer from './data-access-events.reducer';
import * as DataAccessEventsSelectors from './data-access-events.selectors';

import { DataAccessEventsService } from '../../../services/events/data-access-events.service';
import { DataAccessExhibitorService } from '../../../services/exhibitors/data-access-exhibitors.service';
import { DataAccessFairsFacade } from '../../fairs/entity/data-access-fairs.facade';

@Injectable()
export class DataAccessEventsEffects {
  loadEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataAccessEventsActions.eventOpened, DataAccessEventsActions.contributorPageOpened),
      withLatestFrom(this.store.pipe(select(DataAccessEventsSelectors.getEvent)), this.fairsFacade.fairId$),
      filter(([_, selectedEvent, __]) => !selectedEvent),
      switchMap(([action, _, fairId]) =>
        this.eventsService.getEvent(fairId, action.eventUuid).pipe(
          map((result) => {
            return DataAccessEventsActions.eventLoadSucceeded({
              event: result,
            });
          }),
          catchError((err) => of(DataAccessEventsActions.eventLoadFailed({ error: err.status.toString() })))
        )
      )
    )
  );

  fairId$: Observable<string>;

  constructor(
    private readonly actions$: Actions,
    private store: Store<DataAccessEventsReducer.EventsState>,
    private eventsService: DataAccessEventsService,
    private exhibitorService: DataAccessExhibitorService,
    private fairsFacade: DataAccessFairsFacade
  ) {
    this.fairId$ = this.fairsFacade.fairId$;
  }
}
